import { render, staticRenderFns } from "./onWork.vue?vue&type=template&id=b84359b4&scoped=true&"
import script from "./onWork.vue?vue&type=script&lang=js&"
export * from "./onWork.vue?vue&type=script&lang=js&"
import style0 from "./onWork.vue?vue&type=style&index=0&id=b84359b4&prod&lang=scss&scoped=true&"
import style1 from "./onWork.vue?vue&type=style&index=1&id=b84359b4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b84359b4",
  null
  
)

export default component.exports